import MobilePrinter from './MobilePrinter';

export default MobilePrinter;
